import React, { useState } from 'react';
import { Modal, Input, Button } from 'antd-v5';

const LargeAudienceConfirmModal = ({ open, onCancel, onConfirm, audienceCount, estimatedCost }) => {
  const [confirmValue, setConfirmValue] = useState('');

  const countStr = String(audienceCount);
  const isMatch = confirmValue === countStr;

  const handleAfterClose = () => {
    setConfirmValue('');
  };

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      afterClose={handleAfterClose}
      footer={null}
      title={
        <span>
          Are you sure you want to message <strong>{audienceCount.toLocaleString()}</strong> clients?
        </span>
      }
    >
      <p>
        Sending a mass message to all <strong>{audienceCount.toLocaleString()}</strong> clients could cost <strong>${Number(estimatedCost).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}</strong> if it
        exceeds your limit for the month.
      </p>
      <p>
        Enter {audienceCount} in the field below to confirm sending this message.
      </p>
      <Input
        value={confirmValue}
        onChange={e => setConfirmValue(e.target.value)}
        placeholder={`Enter ${audienceCount} to confirm`}
        style={{ marginBottom: 16 }}
      />
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
        <Button onClick={onCancel}>Cancel</Button>
        <Button type="primary" disabled={!isMatch} onClick={onConfirm}>
          Confirm
        </Button>
      </div>
    </Modal>
  );
};

export default LargeAudienceConfirmModal;
